module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h1', [_vm._v("Not Found")]), _vm._v(" "), _c('p', [_vm._v("The page you requested is not found.")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-20d2dbd8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/NotFoundPage.vue
// module id = 1401
// module chunks = 1